<template>
  <div>
    <header class="main-header" v-if="user">
      <router-link to="/" class="nav-link" active-class="active-link" exact>Calculator</router-link>
      <router-link to="/khatakharch" class="nav-link" active-class="active-link">KhataKharch</router-link>
      <div class="auth-box">
        <span class="user-id">User: {{ user.id }}</span>
        <button @click="logout" class="logout-btn">Logout</button>
      </div>
    </header>
    <div v-if="!user" class="login-card">
      <button @click="loginWithGoogle" class="google-btn">Login with Google</button>
    </div>
    <router-view v-if="user" :user="user" />
  </div>
</template>

<script>
import { supabase } from './supabase';

export default {
  name: 'App',
  data() {
    return {
      user: null
    };
  },
  created() {
    this.checkAuth();
    supabase.auth.onAuthStateChange((_event, session) => {
      this.user = session?.user || null;
    });
  },
  methods: {
    async checkAuth() {
      const { data } = await supabase.auth.getUser();
      this.user = data?.user || null;
    },
    async loginWithGoogle() {
      await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: { redirectTo: window.location.origin }
      });
    },
    async logout() {
      await supabase.auth.signOut();
      this.user = null;
    }
  }
};
</script>

<style>
#app {
  font-family: "Segoe UI", Arial, sans-serif;
  text-align: center;
  color: #333;
  margin-top: 0px;
}
.main-header {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  background: #2563eb;
  padding: 14px 0;
  margin-bottom: 0px;
}
.nav-link {
  color: #fff;
  text-decoration: none;
  font-size: 1.08rem;
  font-weight: 500;
  padding: 6px 18px;
  border-radius: 5px;
  transition: background 0.2s, color 0.2s;
}
.nav-link:hover {
  background: #1746a2;
  color: #fff;
}
.active-link {
  background: #fff;
  color: #2563eb !important;
}
.auth-box {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 12px;
}
.google-btn, .logout-btn {
  background: #4285F4;
  color: #fff;
  font-size: 1rem;
  padding: 6px 18px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.2s;
}
.logout-btn {
  background: #e74c3c;
}
.google-btn:hover {
  background: #3367d6;
}
.logout-btn:hover {
  background: #c0392b;
}
.user-id {
  color: #fff;
  font-size: 0.95rem;
  margin-right: 8px;
  font-weight: 500;
}
.login-card {
  margin: 60px auto;
  text-align: center;
}
</style>